import {Pipe, PipeTransform} from '@angular/core';
import {
    AttributeEntityItem,
    PIIShieldAction,
    RequestedAction,
    RequestedAttributeModel,
    RequestedOrganizationModel,
    SchoolRole
} from '@app/core/model/integration-models';
import {SchoolProfileModel} from '@app/core/model/entity-profile';

@Pipe({
    name: 'ngcModifiedByClass'
})
export class NgcModifiedByClassPipe implements PipeTransform {

    transform(
        entity: AttributeEntityItem | SchoolProfileModel,
        isSensitiveDataAttribute?: boolean,
        requestedAction?: RequestedAction,
    ): string {
        let result = 'mb-no-changes';

        if (entity && entity.modifiedBy) {

            if (isSensitiveDataAttribute) {
                if (requestedAction) {
                    if (requestedAction === RequestedAction.ADD) {
                        result = 'mb-REMOVE';
                    }
                    if (requestedAction === RequestedAction.REMOVE) {
                        result = 'mb-ADD';
                    }
                } else {
                    if (entity.modifiedBy.requestedAction) {
                        if ((entity.modifiedBy.requestedAction === RequestedAction.ADD)
                            || ((entity.modifiedBy.requestedAction === RequestedAction.PII_SHIELD_UPDATE)
                                && ((<RequestedAttributeModel>entity.modifiedBy).piiShieldAction === PIIShieldAction.TRANSFORM))) {
                            result = 'mb-ADD';
                        }
                        if ((entity.modifiedBy.requestedAction === RequestedAction.REMOVE)
                            || ((entity.modifiedBy.requestedAction === RequestedAction.PII_SHIELD_UPDATE)
                                && ((<RequestedAttributeModel>entity.modifiedBy).piiShieldAction !== PIIShieldAction.TRANSFORM))) {
                            result = 'mb-REMOVE';
                        }
                    }
                }

            } else {
                result = 'mb-' + entity.modifiedBy.requestedAction;
            }


            if ((<RequestedOrganizationModel><unknown>entity).activatedRolesForSchool
                && (entity.modifiedBy.requestedAction === RequestedAction.UPDATE)) {
                result = 'mb-no-changes';
            }
        } else {
            if (entity
                && (<SchoolRole><unknown>entity).requestedAction
                && (<SchoolRole><unknown>entity).sourceType
                && (<SchoolRole><unknown>entity).targetType) {
                result = 'mb-' + (<SchoolRole><unknown>entity).requestedAction;
            }
        }

        return result;
    }
}
